import { ChevronRight, Play } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { AutoPlayAnimation } from './AutoPlayAnimation'
import { DEMO_PLAY } from './SamplePlays'

type HeroProps = {
	onGetStarted: () => void
}

export function Hero({ onGetStarted }: HeroProps) {
	return (
		<section className="landing-hero">
			<div className="landing-hero-container">
				<div className="landing-hero-content">
					<span className="landing-hero-eyebrow">The modern playbook</span>
					<h1 className="landing-hero-headline">
						Create plays in minutes,<br />not hours.
					</h1>
					<p className="landing-hero-subhead">
						The fastest, most intuitive play drawing tool for football coaches.
						Zero learning curve.
					</p>
					<div className="landing-hero-ctas">
						<Button
							variant="action"
							size="lg"
							onClick={onGetStarted}
							className="landing-hero-cta-primary"
						>
							Get Early Access
							<ChevronRight className="landing-hero-cta-icon" />
						</Button>
						<a href="#how-it-works" className="landing-hero-cta-secondary">
							<Play className="landing-hero-cta-icon" />
							See How It Works
						</a>
					</div>
				</div>

				<div className="landing-hero-demo">
					<AutoPlayAnimation play={DEMO_PLAY} />
				</div>
			</div>
		</section>
	)
}
